<adapt-feature-guidance [configItem]="configItem">
    <p>Groups <em class="text-muted">(formerly known as Teams)</em> are the key building blocks of your organisation
        structure. This is where the work of the organisation is
        organised, tracked and done.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem">
    <h3>Group types</h3>
    <p class="text-muted">Customise the appearance of your groups. Your colours and icon will be visible on the
        organisation map, and whenever the group is linked to.</p>

    <div class="row">
        <div class="col-3 d-flex flex-column gap-2">
            <dx-list [items]="teamTypeConfigurations"
                     [selectedItems]="[selectedConfig]"
                     selectionMode="single"
                     [focusStateEnabled]="false"
                     (onSelectionChanged)="onSelectionChanged($event)"
                     (onContentReady)="onContentReady($event)"
                     (onItemReordered)="onItemReordered($event)"
                     height="auto">
                <dxo-list-item-dragging [allowReordering]="true"></dxo-list-item-dragging>

                <div *dxTemplate="let data of 'item'"
                     class="list-item d-flex gap-2 align-items-center list-item-team-type ps-1 pe-2">
                    <adapt-display-team-type [teamTypeConfiguration]="data"
                                             [showName]="true"></adapt-display-team-type>
                    <div class="d-flex gap-2 align-items-center ms-auto">
                        @if (data.code !== TeamTypeCode.Team) {
                            <button adaptButtonIcon="fal fa-fw fa-trash"
                                    class="btn btn-link"
                                    adaptTooltip="Delete this team type"
                                    [adaptBlockingClick]="deleteTeamTypeConfiguration"
                                    [adaptBlockingClickParam]="data"
                                    [stopPropagation]="true"
                                    [unsubscribeOnDestroy]="false"
                                    data-test="delete-team-type-button"></button>
                        } @else {
                            <img src="/content/shell/images/Adapt_Icon_Clementine_Outline.svg"
                                 adaptTooltip="This group type is required for system functions, it cannot be deleted."/>
                        }
                    </div>
                </div>
            </dx-list>

            <button adaptButton="add"
                    [adaptBlockingClick]="addTeamType">group</button>
        </div>
        @if (selectedConfig) {
            <div class="col-md-9">
                <div class="form-group">
                    <label>Name</label>
                    <dx-text-box #focus
                                 [(value)]="selectedConfig.name"
                                 (valueChange)="updateDummyTeam()"
                                 [adaptValidateEntity]="selectedConfig"
                                 adaptValidateEntityProperty="name"></dx-text-box>
                </div>
                <div class="form-group">
                    <label>Icon</label>
                    <adapt-icon-picker [value]="selectedConfig.icon ?? undefined"
                                       (valueChange)="selectedConfig.icon = $event; updateDummyTeam()"></adapt-icon-picker>
                </div>
                <div class="form-group">
                    <label>Icon colour</label>
                    <adapt-colour-picker [(value)]="selectedConfig.iconColour"
                                         (valueChange)="updateDummyTeam()"
                                         [presetGroups]="iconColourPresetGroups"></adapt-colour-picker>
                </div>
                <div class="form-group">
                    <label>Background colour</label>
                    <adapt-colour-picker [(value)]="selectedConfig.backgroundColour"
                                         (valueChange)="updateDummyTeam()"
                                         [presetGroups]="backgroundColourPresetGroups"
                                         presetSet="light"></adapt-colour-picker>
                </div>
                @if (dummyTeam; as team) {
                    <div class="form-group">
                        <label>Preview</label>
                        <adapt-team-card class="pe-none"
                                         [team]="team"
                                         [showChildCount]="false"></adapt-team-card>
                    </div>
                }
            </div>
        }
    </div>
</adapt-feature-configuration>
